/* 
 *  Created by SGiri 02/14/2018
 */

import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GridOptions } from "ag-grid/main";
import { AppUtil } from '~util/app.util';
import { CommonService } from '~util/common.service';
import { Constants } from '~util/app.constant';
import { DashboardService } from '~config/services/dashboard.service';
import { EditComponent } from '~config/edit/edit.component';
import { Router } from '@angular/router';

@Component({
    selector: 'kpi-grid',
    templateUrl: './kpi-grid.component.html',
    styleUrls: ['./kpi-grid.component.css']
})
export class KpiGridComponent implements OnChanges {

    @Input() dashboardId;

    gridOptions: GridOptions;
    columnDefs: any[]
    rowData: any[];
    isDisabled: boolean = true;
    style: {};
    tempRowData: {};
    selectedRow: {};

    constructor(private service: DashboardService, private util: AppUtil, private commonService: CommonService, private router: Router) {
        this.gridOptions = util.getGridOptions('Please select dashbaord');
        this.columnDefs = this.getColumnDef();
        this.style = Constants.gridStyle;
    }

    /*
    * This method will be called when we change dashboard id from drop down
    */
    ngOnChanges(changes: SimpleChanges) {
        //Disable Export button
        this.isDisabled = true;
        this.selectedRow = null;

        if (changes.dashboardId.currentValue == -1) {
            this.rowData = [];
        }
        else {
            this.gridOptions.api.showLoadingOverlay();
            this.getRowData();
            this.gridOptions.api.refreshCells();
        }
    }

    onGridReady(params) {
        // params.api.sizeColumnsToFit();
    }

    onSelectionChanged() {
        this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
    }

    getRowData() {
        this.service.getStandardDashboardRowData(this.dashboardId, true).subscribe((data: any[]) => {
            this.rowData = data;
            this.rowData.forEach(row => {
                row['locked'] = true;
                row['dashboardId'] = this.dashboardId;
            })
            this.isDisabled = false;
        });
    }

    getColumnDef() {
        return [
            { headerName: "Lock", width: 70, cellRendererFramework: EditComponent, editable: false, hide: this.commonService.isHidden() },
            { headerName: "KPI Id", width: 100, field: "kpiId", editable: false },
            { headerName: "KPI Name", field: "kpiName", editable: this.isEditable },
            { headerName: "Report Id", field: "reportId", editable: this.isEditable },
            { headerName: "Scorecard Report Id", field: "scorecardReportId", editable: this.isEditable },
            { headerName: "KPI Selection", field: "kpiSelection", editable: this.isEditable },
            { headerName: "Created Date", field: "createdDate", width: 130, editable: false, valueFormatter: this.util.dateFormatter },
            { headerName: "Modified Date", field: "modifiedDate", width: 130, editable: false, valueFormatter: this.util.dateFormatter },
            { headerName: "Release Version", field: "releaseVersion", width: 150, editable: this.isEditable },
            { headerName: "Star Report Enabled", field: "starReportEnabled", width: 150, editable: this.isEditable },
            { headerName: "Sort Criteria", field: "starSortCriteria", width: 150, editable: this.isEditable },
            { headerName: "Kpi Type", field: "kpiType", width: 150, editable: this.isEditable },
            { headerName: "Decimal Places", field: "decimalPlaces", width: 150, editable: this.isEditable },
            { headerName: "Excel Format", field: "excelFormat", width: 150, editable: this.isEditable },
            { headerName: "Edit Mapping", width: 150, cellRendererFramework: EditComponent, hide: this.commonService.isHidden() }
        ];
    }

    exportToCSV() {
        this.gridOptions.api.exportDataAsCsv();
    }

    rowEditingStarted(params) {
        this.tempRowData = { ...params.data };
        delete this.tempRowData['locked'];
    }

    rowEditingStopped(params) {
        var tempRowData2 = { ...params.data };
        delete tempRowData2['locked'];

        if (JSON.stringify(this.tempRowData) !== JSON.stringify(tempRowData2) && !params.data.locked) {
            params.api.stopEditing(true);
            this.gridOptions.api.showLoadingOverlay();
            this.service.saveKpiData(params.data).subscribe(data => {
                params.data.locked = true;
                this.gridOptions.api.hideOverlay();
            });
        }
    }

    isEditable(params) {
        return !params.node.data.locked;
    }
}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/kpi-grid/kpi-grid.component.ts